import { useEffect, useState } from "react";
import { Loader2, CheckCircle2, XCircle, Clock, Lock } from "lucide-react";
import { api } from "@/lib/api";

function StatusBadge({ item }) {
  if (item.status !== "resolved") {
    return (
      <span className="flex items-center gap-1 rounded-full bg-amber-100 px-2.5 py-1 text-xs font-bold text-amber-700">
        <Lock className="h-3 w-3" /> In attesa
      </span>
    );
  }
  if (item.is_correct) {
    return (
      <span className="flex items-center gap-1 rounded-full bg-green-100 px-2.5 py-1 text-xs font-bold text-green-700">
        <CheckCircle2 className="h-3 w-3" /> Corretta +{item.points_awarded}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1 rounded-full bg-red-100 px-2.5 py-1 text-xs font-bold text-red-600">
      <XCircle className="h-3 w-3" /> Errata
    </span>
  );
}

export default function History() {
  const [items, setItems] = useState(null);

  useEffect(() => { api.get("/predictions/history").then((r) => setItems(r.data)); }, []);

  if (!items) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-green-500" /></div>;

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-4xl font-black uppercase tracking-tight text-zinc-950">I tuoi pronostici</h1>
        <p className="text-sm font-semibold text-zinc-500">Storico delle risposte: tutte congelate al momento dell'invio.</p>
      </header>

      {items.length === 0 ? (
        <div data-testid="history-empty" className="rounded-3xl border-2 border-dashed border-slate-300 bg-white p-10 text-center text-zinc-500">
          Non hai ancora fatto pronostici. Vai in home e inizia a giocare!
        </div>
      ) : (
        <div className="space-y-3" data-testid="history-list">
          {items.map((item) => (
            <div key={item.answer_id} data-testid={`history-item-${item.prediction_id}`}
              className="rounded-2xl border border-slate-200 bg-white p-4">
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-display text-lg font-bold uppercase leading-tight text-zinc-950">{item.question}</p>
                  <p className="mt-1 text-sm text-zinc-600">
                    La tua risposta: <span className="font-bold text-zinc-950">{item.chosen_option}</span>
                  </p>
                  <p className="mt-1 flex items-center gap-1 text-[11px] font-semibold uppercase text-zinc-400">
                    <Clock className="h-3 w-3" /> {new Date(item.created_at).toLocaleString("it-IT")}
                  </p>
                </div>
                <StatusBadge item={item} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
